"use client";

import React from "react";

import * as S from "./styles";

import imageDefault from "@/assets/images/config-3-assinaturas.jpg";
import ButtonArround from "../buttonArround";
import { Calendar1, ClipboardPen, User } from "lucide-react";

const BoxInfoEstablishment = ({ data }: { data: any }) => {
  return (
    <S.BoxInfo>
      <S.HeaderBoxInfo>
        <ButtonArround />
        <S.ImageComponet src={imageDefault} />
        <S.EstablishmentName>
          {data?.establishment?.name ?? "Nome da Estabelecimento"}
        </S.EstablishmentName>
      </S.HeaderBoxInfo>
      <S.BodyBoxInfo>
        <div>
          <S.TitleDescription>Finalize a sua Assinatura</S.TitleDescription>
          <S.SubTitle>
            {data?.subscription?.name} e aproveite os seus benefícios.
          </S.SubTitle>
        </div>
        <S.Description>{data?.subscription?.description ?? ""}</S.Description>
        <S.ListItems>
          <S.Items>
            <User />
            {data?.client?.full_name ?? "Nome do Cliente"}
          </S.Items>
          <S.Items>
            <ClipboardPen />
            {data?.subscription?.name}
          </S.Items>
          <S.Items>
            <Calendar1 />
            {data?.clientSubscription?.expiration_date ?? ""}
          </S.Items>
        </S.ListItems>
        <S.Value>R$ {data?.subscription?.value ?? ""}</S.Value>
      </S.BodyBoxInfo>
    </S.BoxInfo>
  );
};

export default BoxInfoEstablishment;
